<script>
  export default {
    props: ["dataCard"],
    data() {
      return {
        showModal: false,
      };
    },
    computed: {
      hasAction() {
        return !!this.dataCard?.action;
      },
      hasModal() {
        return !!this.dataCard?.modal;
      },
      isClickable() {
        return this.hasAction || this.hasModal;
      },
    },
    methods: {
      handleClick() {
        if (this.hasAction) {
          this.execItemAction();
        }
      },
      handleButtonClick() {
        if (this.hasModal) {
          this.openModal();
        } else if (this.hasAction) {
          this.execItemAction();
        }
      },
      execItemAction() {
        if (!this.hasAction) {
          return;
        }
        this.dataCard?.action();
      },
      openModal() {
        this.showModal = true;
        document.body.style.overflow = "hidden";
      },
      closeModal() {
        this.showModal = false;
        document.body.style.overflow = "";
      },
      handleMaskClick(event) {
        if (event.target === event.currentTarget) {
          this.closeModal();
        }
      },
    },
    beforeDestroy() {
      document.body.style.overflow = "";
    },
  };
</script>
<template>
  <div :class="['cardHome', hasAction && 'cardHome--action']" @click="handleClick">
    <div class="cardHome__name">
      <iconic :class="`cardHome__icon cardHome__icon--${dataCard.iconClass}`" :name="dataCard.icon" />
      <p class="cardHome__title">{{ dataCard.title }}</p>
    </div>
    <div class="cardHome__body">
      <p class="cardHome__text" v-html="dataCard.content"></p>
      <div class="cardHome__button" v-if="dataCard.button" @click.stop="handleButtonClick">{{ dataCard.button }}</div>
    </div>
    <transition name="modal-fade">
      <div v-if="showModal && hasModal" class="cardHome__modal" @click="handleMaskClick">
        <div class="cardHome__modal-container">
          <div class="cardHome__modal-header">
            <h2 class="cardHome__modal-title">{{ dataCard.modal.title }}</h2>
            <button class="cardHome__modal-close" @click="closeModal">
              <iconic name="close" />
            </button>
          </div>
          <div class="cardHome__modal-body" v-html="dataCard.modal.content"></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style lang="scss">
  .cardHome {
    width: 100%;
    max-width: 570px;
    padding: 15px 15px;
    border-radius: 15px;
    box-shadow: 0px 4px 16px 0px #f238471a;
    background: #ffffff;
    &--action {
      cursor: pointer;
    }
    &__name {
      display: flex;
      gap: 10px;
      margin: 0px 0px 5px 0px;
    }
    &__icon {
      &--success {
        color: #20c306;
      }
      &--primary {
        color: $primary-color;
      }
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &__title {
      font-family: $newFont_medium;
      color: #272727;
    }
    &__text {
      font-family: $newFont_regular;
      color: #3d3d3d;
      font-size: 14px;
    }
    &__button {
      align-self: flex-start;
      padding: 5px 12px;
      border-radius: 50px;
      background-color: $primary-color;
      color: #ffffff;
      font-family: $newFont_medium;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &:hover {
        background-color: lighten($primary-color, 3%);
      }
    }
    &__modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      padding: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      @include Flex();
      z-index: 10;
      overflow-y: auto;
    }

    &__modal-container {
      background: #ffffff;
      border-radius: 12px;
      width: 100%;
      max-width: 600px;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
      position: relative;
    }

    &__modal-header {
      @include Flex(row, space-between, center);
      padding: 20px 25px;
      border-bottom: 1px solid #e0e0e0;
      flex-shrink: 0;
    }

    &__modal-title {
      font-family: $newFont_medium;
      color: $primary-color;
      font-size: 20px;
      font-weight: 500;
      text-transform: none;
    }

    &__modal-close {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #3d3d3d;
      font-size: 16px;
      transition: all 0.3s ease;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      flex-shrink: 0;

      &:hover {
        background-color: #f5f5f5;
        color: #333;
      }
    }

    &__modal-body {
      padding: 10px 25px;
      overflow-y: auto;
      font-family: $newFont_regular;
      color: #3d3d3d;
      font-size: 14px;
      line-height: 1.6;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: #b8b7b7;
        border-radius: 10px;

        &:hover {
          background: #a8a8a8;
        }
      }
    }
  }

  .modal-paragraph {
    line-height: 1.6;
    color: #3d3d3d;
    font-family: $newFont_regular;
    font-size: 15px;
  }

  .modal-title {
    margin: 12px 0;
    padding: 0;
    text-transform: none;
    font-family: $newFont_medium;
    color: #272727;
    font-weight: 500;
    line-height: 1.3;
    font-size: 18px;
  }

  .modal-list {
    margin: 15px 0;
    padding-left: 30px;
    list-style-position: outside;

    &--nested {
      margin: 8px 0;
      padding-left: 25px;
    }
  }

  .modal-list-item {
    margin: 8px 0;
    padding-left: 8px;
    line-height: 1.6;
    color: #3d3d3d;
    display: list-item;
    list-style-type: disc;
    font-family: $newFont_regular;
    font-size: 15px;
  }

  .modal-list--nested .modal-list-item {
    list-style-type: circle;
  }

  .modal-bold {
    font-family: $newFont_medium;
    font-weight: 600;
    color: #272727;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active .cardHome__modal-container,
  .modal-fade-leave-active .cardHome__modal-container {
    transition: transform 0.3s ease;
  }

  .modal-fade-enter .cardHome__modal-container,
  .modal-fade-leave-to .cardHome__modal-container {
    transform: scale(0.9);
  }
</style>
